/* toggle newsletter form */

let handler     = document.getElementById( "open-close-news" ),
	newsWrapper = document.getElementById( 'newsletter-wrapper' );

function openClose() {
	if ( newsWrapper.style.display === 'block' ) {
		newsWrapper.style.display = 'none';
		newsWrapper.style.width   = '0'
	} else {
		newsWrapper.style.display = 'block';
		newsWrapper.style.width   = '100%';
	}
}

handler.addEventListener( "click", openClose );

window.addEventListener(
	'click',
	function( e ) {
		if ( ! newsWrapper.contains( e.target ) && ! handler.contains( e.target ) && newsWrapper.style.display === 'block' ) {
			newsWrapper.style.display = 'none';
			newsWrapper.style.width   = '0'
		}
	}
);
